/**
 * 글 상세의 고정 문구 — 글이 나간 언어로.
 * @description 문구는 주소가 아니라 **본문이 나간 언어**([BlogItem.language])를 따른다. 본문이
 *   스페인어인데 곁글·읽는 시간·다음 글 제목만 영어면 한 화면에 두 언어가 섞인다.
 *
 *   사이트 공용 틀(헤더 · 푸터 · 앱 설치 띠)은 여기 없다. 그것들은 아직 한 언어다.
 */
import type { BlogItem } from "../dtos";
import { toBlogLanguage, type BlogLanguage } from "@/shared/config";

export interface BlogCopy {
  minRead: (minutes: number) => string;
  meta: { topic: string; author: string; date: string; read: string };
  related: string;
  appCta: { title: string; description: string; action: string };
  share: { label: string; copied: string };
}

const BLOG_COPY: Record<BlogLanguage, BlogCopy> = {
  en: {
    minRead: (minutes) => `${minutes} min read`,
    meta: {
      topic: "Topic",
      author: "Written by",
      date: "Published",
      read: "Read time",
    },
    related: "More stories",
    appCta: {
      title: "Continue in the Fanwork app",
      description:
        "Comments, likes and the author's other posts live in the app.",
      action: "Open the app",
    },
    share: { label: "Share", copied: "Link copied" },
  },
  es: {
    minRead: (minutes) => `${minutes} min de lectura`,
    meta: {
      topic: "Tema",
      author: "Escrito por",
      date: "Publicado",
      read: "Tiempo de lectura",
    },
    related: "Más historias",
    appCta: {
      title: "Continúa en la app de Fanwork",
      description:
        "Los comentarios, los me gusta y las demás publicaciones del autor están en la app.",
      action: "Abrir la app",
    },
    share: { label: "Compartir", copied: "Enlace copiado" },
  },
};

/** 글이 나간 언어의 문구. 언어가 비어 오면(앱 글) 원문 문구다 */
export const blogCopyOf = (post: Pick<BlogItem, "language">): BlogCopy =>
  BLOG_COPY[toBlogLanguage(post.language)];
